import { Box } from "@mui/system";

type StyledImageProps = {
  src: string;
};

export const StyledImage = (props: StyledImageProps) => {
  const { src } = props;

  return (
    <Box
      sx={{
        "& img": {
          borderRadius: 2,
          boxShadow: 3,
        },
      }}
    >
      <img
        src={src}
        style={{
          width: "100%",
          height: "auto",
          display: "block",
          border: "1px solid #ccc",
        }}
        alt="x"
      />
    </Box>
  );
};
